export const methodology = [
  {
    step: '01',
    title: 'Deep Discovery & Strategic Alignment',
    summary: 'Uncovering your core strengths, measurable impact, and the leadership story only you can tell.',
    details: [
      'In-depth strategy interview and career audit',
      'Achievement and metrics extraction',
      'Target-role and market alignment',
    ],
  },
  {
    step: '02',
    title: 'Precision Engineering',
    summary: 'Crafting high-impact executive resumes, biographies, and LinkedIn narratives with exacting care.',
    details: [
      'Executive resume, CV, and board biography',
      'LinkedIn and digital brand narrative',
      'Collaborative review and refinement',
    ],
  },
  {
    step: '03',
    title: 'Search Execution & Positioning',
    summary: 'Interview coaching, board dossier alignment, and confident navigation of the executive market.',
    details: [
      'Interview and executive presence coaching',
      'Board dossier and search-firm alignment',
      'Offer negotiation and transition support',
    ],
  },
]

export const testimonials = [
  {
    quote:
      'Tom didn\u2019t simply rewrite my resume \u2014 he re-architected how decision-makers saw me. Within ten weeks I was in three final-round conversations and accepted a CTO role with a private-equity-backed firm.',
    name: 'Michael R.',
    title: 'Chief Technology Officer',
    outcome: 'CTO offer secured in 10 weeks',
  },
  {
    quote:
      'The interview preparation was the most rigorous I have ever experienced. I walked into the panel composed and precise, and negotiated a package well beyond my expectations.',
    name: 'Sandra K.',
    title: 'VP of Operations',
    outcome: '32% increase in base compensation',
  },
  {
    quote:
      'After Tom rebuilt my LinkedIn presence, retained search firms began reaching out within the month. My profile finally reflected the scope of my leadership.',
    name: 'David L.',
    title: 'Senior Director, Strategy',
    outcome: '4 retained-search inquiries in 30 days',
  },
]

export const audiences = [
  {
    title: 'C-Suite & Board Candidates',
    description: 'CEOs, CFOs, CTOs, COOs, and directors preparing for their next appointment or board seat.',
  },
  {
    title: 'Senior Leaders & Vice Presidents',
    description: 'Executives advancing toward enterprise-level scope, P&L ownership, and strategic influence.',
  },
  {
    title: 'Mid-to-Late Career Transitioners',
    description: 'Accomplished professionals pivoting sectors, re-entering the market, or redefining their next chapter.',
  },
  {
    title: 'Institutional Partners',
    description: 'Universities, associations, and organizations seeking expert career programming and training.',
  },
]

export const career = [
  {
    organization: 'Write for Me Resumes',
    role: 'Founder & Principal Career Strategist',
    period: '17+ years',
    description:
      'Leads a premier career advisory practice that has guided more than 1,150 mid-level and executive clients through resume engineering, interview coaching, and strategic transition.',
  },
  {
    organization: 'Kennesaw State University',
    role: 'Associate Vice President & Executive Director',
    period: 'Higher education leadership',
    description:
      'Directed institution-wide career strategy, employer partnerships, and professional development for one of the largest universities in the Southeast.',
  },
  {
    organization: 'University of the Pacific',
    role: 'Executive Director',
    period: 'Higher education leadership',
    description:
      'Led career services and employer engagement, building programs that connected students and alumni to high-value opportunities.',
  },
  {
    organization: 'Elon University',
    role: 'Executive Director',
    period: 'Higher education leadership',
    description:
      'Oversaw nationally recognized career development initiatives at a university renowned for experiential learning.',
  },
]

export const publications = [
  {
    area: 'Career Counseling',
    title: 'Evidence-based approaches to career decision-making and development',
    description:
      'Published contributions examining how counseling frameworks improve career clarity, confidence, and long-term outcomes.',
  },
  {
    area: 'Personal Adjustment',
    title: 'Psychological adjustment through professional and life transitions',
    description:
      'Research on the behavioral dimensions of transition — informing how leaders navigate change with resilience.',
  },
  {
    area: 'Training Frameworks',
    title: 'Structured training models for counselors and career professionals',
    description:
      'Frameworks for developing practitioner skill, now embedded in the methodology behind every client engagement.',
  },
]
